import "../../css/Containers/ContainerStyles.css";
import React, { useEffect, useRef } from "react";
import { Icon } from "@iconify/react";
import { Colors } from "../../utils/colors";
import { ThemeStyle } from "../../hooks/useTheme";
import { HorizontalDivider } from "../Dividers/HorizontalDivider";
import ExpandableBox from "./ExpandableBox";
import { isDesktop } from "react-device-detect";

export enum PopupModalContainerWidth {
  NORMAL,
  SMALL,
  WIDE,
  NARROW,
}

type PopupModalContainerProps = {
  customHeader?: React.ReactNode;
  headerComp?: string | React.ReactNode;
  headerLeftComp?: React.ReactNode;
  headerRightComp?: React.ReactNode;
  subHeaderComp?: string | React.ReactNode;
  icon?: React.ReactNode;
  valueComp: React.ReactNode;
  theme?: ThemeStyle;
  headerLeftIcon?: React.ReactNode;
  altPadding?: number;
  noExit?: boolean;
  noDivider?: boolean;
  dividerTwo?: boolean;
  closeModal: () => void;
  closeOnOutsidePress?: boolean;
  modalContentWidth?: PopupModalContainerWidth;
  fixedBottomContent?: React.ReactNode;
  hideModal?: boolean;
  positionOnTop?: number;
};

const PopupModalContainer = (props: PopupModalContainerProps) => {
  const {
    customHeader,
    headerComp,
    headerLeftComp,
    headerRightComp,
    subHeaderComp,
    valueComp,
    icon,
    theme,
    headerLeftIcon,
    altPadding,
    noExit,
    noDivider,
    dividerTwo,
    closeModal,
    closeOnOutsidePress,
    modalContentWidth,
    fixedBottomContent,
    hideModal,
    positionOnTop,
  } = props;

  const ref = useRef<any>(null);
  useEffect(() => {
    const handler = (event: any) => {
      if (ref.current && !ref.current.contains(event.target)) {
        closeModal();
        event.preventDefault();
        event.stopPropagation();
      }
    };
    document.addEventListener("mousedown", handler, { passive: false });
    document.addEventListener("touchstart", handler, { passive: false });
    return () => {
      // Cleanup the event listener
      document.removeEventListener("mousedown", handler);
      document.removeEventListener("touchstart", handler);
    };
  }, [closeModal]);

  return (
    <>
      {!hideModal ? (
        <div className="modalBackground">
          <ExpandableBox>
            <div
              ref={closeOnOutsidePress ? ref : null}
              className={
                (modalContentWidth
                  ? modalContentWidth === PopupModalContainerWidth.WIDE
                    ? "wideModalContent"
                    : modalContentWidth === PopupModalContainerWidth.SMALL
                      ? "smallModalContent"
                      : modalContentWidth === PopupModalContainerWidth.NARROW
                        ? "narrowModalContent"
                        : "modalContent"
                  : "modalContent") + " HideScrollbar"
              }
              style={{
                ...theme?.SecondaryBG,
                position: positionOnTop ? "absolute" : "relative",
                top: positionOnTop || 0,
                left: positionOnTop ? "50%" : 0,
                right: positionOnTop ? "auto" : 0,
                transform: positionOnTop ? "translateX(-50%)" : "none",
              }}
            >
              <div style={{ paddingInline: "14px" }}>{customHeader}</div>
              <div className="ColumnNormal">
                {headerLeftIcon}
                <div
                  className="AlignedRowSpaced"
                  style={{ paddingInline: "14px" }}
                >
                  <div className="AlignedRowSpaced" style={{ width: "100%" }}>
                    {headerLeftComp}
                    <div
                      className="AlignedRow"
                      style={{ gap: 5, flex: 1, minWidth: 0 }}
                    >
                      <h4
                        className="AboutSubtitle"
                        style={{
                          ...theme?.PrimaryText,
                          flex: 1,
                          minWidth: 0,
                        }}
                      >
                        {headerComp}
                      </h4>
                      {icon}
                    </div>
                    {headerRightComp}
                  </div>
                  {!noExit ? (
                    <Icon
                      icon={"ion:close-circle"}
                      height={24}
                      onClick={closeModal}
                      style={{ color: Colors.GRAY1, cursor: "pointer" }}
                    />
                  ) : null}
                </div>
                {subHeaderComp ? (
                  <div
                    style={{
                      color: Colors.GRAY1,
                      fontSize: 12,
                      paddingInline: "14px",
                      paddingTop: 7,
                    }}
                  >
                    {subHeaderComp}
                  </div>
                ) : null}
                {!noDivider ? (
                  <hr
                    style={{
                      marginBlock: 14,
                      borderColor: theme
                        ? theme.DividerColor.borderColor
                        : Colors.GRAY11,
                      borderWidth: 1.5,
                    }}
                  />
                ) : null}
                <div
                  className="HideScrollbar"
                  style={{
                    maxHeight: isDesktop ? "80vh" : "50vh",
                    overflowY: "scroll",
                    paddingInline: altPadding ?? 14,
                  }}
                >
                  {valueComp}
                </div>
                {dividerTwo ? <HorizontalDivider altMargin={14} /> : null}
                {fixedBottomContent ? <div>{fixedBottomContent}</div> : null}
              </div>
            </div>
          </ExpandableBox>
        </div>
      ) : null}
    </>
  );
};

export default PopupModalContainer;
